const LOG_PREFIX = '[GET - Fetch Articles by Products]';

const fetchArticlesByCategoriesFnKey = 'fetch-articles-by-categories-query-fn';

export default { LOG_PREFIX, fetchArticlesByCategoriesFnKey };
